import type { ColorSystemOptions } from "@mui/material/styles";

export const lightEffects: ColorSystemOptions["appEffects"] = {
  glass: {
    blurMd: "12px",
    blurSm: "8px",
    blurXs: "4px",
    radiusMd: "12px",
    radiusSm: "8px",
    saturateMd: "160%",
    saturateSm: "125%",
    saturateXs: "80%",
    transitionSurface: "all 0.2s ease"
  },

  opacity: {
    disabled: 0.6,
    softBorder: 0.12,
    strongBorder: 0.24
  },

  shadow: {
    avatar:
      "0 2px 4px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06)",
    card: "0 5px 4px rgba(0, 0, 0, 0.1)",
    depth:
      "linear-gradient(to bottom, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.05), transparent)",
    insetMd: "inset 3px 3px 33px -6px rgba(255, 255, 255, 0.88)",
    insetSm: "inset 3px 3px 33px -20px #F7F7FC",

    lg: "0px 2px 2px -1px #0A0D120A, 0px 4px 6px -2px #0A0D1208, 0px 12px 16px -4px #0A0D1214", //Profile modal / drawer-like depth OR BaseTooltip stack
    md: "0px 10px 10px rgba(0,0,0,0.1)", //TargetCard.tsx, LocalContentCard.tsx, GlassCard.tsx
    pill: "0 2px 4px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06)",

    sm: "0 2px 4px rgba(0, 0, 0, 0.05)", // EmployeeTimeline.tsx, WhiteGrid.tsx, GlassCard.tsx
    xs: "0 1px 2px 0 rgba(10, 13, 18, 0.05)" //Cells.tsx, SocialSpendDataGrid.tsx, DropDownButtonGridCell.tsx
  }
};
